import { Brand, createBranded } from '@deltasierra/type-utilities';

export type SendgridVerifiedSenderId = Brand<number, 'SendgridVerifiedSenderId'>;
export const SendgridVerifiedSenderId = createBranded<SendgridVerifiedSenderId>();

export interface SenderDetails {
    name: string;
    email: string;
}

export type SendgridVerifiedSender = SenderDetails & {
    id: SendgridVerifiedSenderId;
    isVerified: boolean;
}
